module.exports = __webpack_public_path__ + "static/fonts/iconfont.83274a5d.woff2";